import React, { useState, useEffect, useRef, useMemo } from 'react'
import { Tile, Form, FormGroup, TextInput, Button, Select, SelectItem } from 'carbon-components-react'
import { Link } from 'react-router-dom'
import { CSVLink } from "react-csv"
import { normalizePhone, deNormalizePhone } from '../../utils/functions/tools/normalizePhone';
import { ClientContactsList } from './clientContacts.tsx';
const { REACT_APP_DEV_API_URL, REACT_APP_PROD_API_URL, NODE_ENV } = process.env;
const API_URL =
    NODE_ENV === 'production' ? process.env.REACT_APP_PROD_API_URL : process.env.REACT_APP_DEV_API_URL;

const ClientContacts = (pageData) => {

    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const searchInput = useRef(null);
    const editContactInput = useRef(null);
    const [phoneInput, setPhoneInput] = useState("");

    const [totalItems, setTotalItems] = useState(0);
    const [firstRowIndex, setFirstRowIndex] = useState(0);
    const [currentPageSize, setCurrentPageSize] = useState(10);

    // Variables for search
    const [contactSearch, setContactSearch] = useState("");

    // Variables for modals and toasts
    const [error, setError] = useState(false);
    const [editContactID, setEditContactID] = useState(false);

    const [openAddContactModal, setOpenAddContactModal] = useState(false);
    const [openEditContactModal, setOpenEditContactModal] = useState(false);

    const addContactForm = useRef();
    const editContactForm = useRef();

    let [openDeleteContactModal, setOpenDeleteContactModal] = useState(false)
    let [contactsToDel, setContactsToDel] = useState(null)

    // General
    const [curDate, setCurDate] = useState(null)

    useEffect(() => {
        document.title = "Client Contacts | WillowBMS"
    }, [pageData.profileId, editContactID])

    let activeCheck = async (e) => {
        var set
        console.log(editContactID)
        // Get current status
        let r = await fetch(`${API_URL}/client/contact/view/${e}/`, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + pageData.authTokens?.access
            },
        })
        let data = await r.json()

        // Set new status
        if (data.is_active == false) {
            set = true
        } else {
            set = false
        }

        // Apply status
        let response = await fetch(`${API_URL}/client/contact/manage/edit/${e}/`, {
            method: "PUT",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + pageData.authTokens?.access
            },
            body: JSON.stringify({
                'id': data.id,
                'first_name': data.first_name,
                'last_name': data.last_name,
                'email': data.email,
                'is_primary': data.is_primary,
                'is_active': set,
            })
        })
        if (response.status === 200){
            pageData.getContacts()
            pageData.showToast("success", "Success", "Client contact status has been changed.")
        } else {
            pageData.showToast("error", "Error", "There was a problem changing the status of the client contact.")
        }
    }

    let editContactSetup = async (id) => {
        let response = await fetch(`${API_URL}/client/contact/view/${id}/`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + pageData.authTokens?.access
            }
        })
        let data = await response.json()
        setEditContactID(data)
        setPhoneInput(normalizePhone(data.phoneNumber))
    }

    let editContact = async (values) => {
        values.preventDefault()
        
        let response = await fetch(`${API_URL}/client/contact/manage/edit/${editContactID.id}/`, {
            method: "PUT",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + pageData.authTokens?.access
            },
            body: JSON.stringify({
                'id': editContactID.id,
                'first_name': values.target.first_name.value,
                'last_name': values.target.last_name.value,
                'is_primary': editContactID.is_primary,
                'is_active': editContactID.is_active,
                'email': values.target.email.value,
                'phoneNumber': deNormalizePhone(values.phoneNumberEditContact),
                'position': values.target.position.value
            })
        })

        if (response.status === 200) {
            pageData.getContacts()
            pageData.getClient(pageData.profileId, pageData.setClient, pageData.setClientAddress, pageData.setClientMailingAddress, pageData.setClientBillingAddress, pageData.API_URL, pageData.authTokens, pageData.setClientCountry)
            pageData.showToast("success", "Success", "Client contact has been edited.")
            setOpenEditContactModal(false)
        } else {
            setError(true)
        }
    }

    let addContact = async (values) => {
        values.preventDefault()
        let response = await fetch(`${API_URL}/client/contact/manage/add/`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + pageData.authTokens?.access
            },
            body: JSON.stringify({
                'first_name': values.target.first_name.value,
                'last_name': values.target.last_name.value,
                'is_primary': false,
                'is_active': true,
                'email': values.target.email.value,
                'client_id': pageData.profileId,
                'phoneNumber': values.target.phoneNumber.value,
                'position': values.target.position.value
            })
        })

        if (response.status === 200) {
            pageData.getContacts()
            pageData.showToast("success", "Success", "Client contact has been added.")
            setOpenAddContactModal(false)
            setError(false)
            document.getElementById("addContact").reset()
        } else {
            setError(true)
        }
    }

    let deleteContact = async (contactID) => {
        let response = await fetch(`${API_URL}/client/contact/manage/delete/${contactID}/`, {
            method: 'DELETE',
            'headers': {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + pageData.authTokens?.access
            }
        })

        if (response.status === 200) {
            pageData.getContacts()
            setOpenDeleteContactModal(false)
            pageData.showToast("success", "Success", "Client contact has been deleted.")
        } else {
            setError(true)
        }
    }

    const contactsData = useMemo(() => {
        let computedClients = search(pageData.contacts);
        setTotalItems(computedClients.length);
        //Current Page slice
        return computedClients.slice(
            firstRowIndex,
            firstRowIndex + currentPageSize
        );
    }, [pageData.contacts, firstRowIndex, currentPageSize, contactSearch]);

    function search(contacts) {
        return contacts.filter(
            (row) =>
                row.email.indexOf(contactSearch) > -1 ||
                row.email.toLowerCase().indexOf(contactSearch) > -1 ||
                row.first_name.indexOf(contactSearch) > -1 ||
                row.first_name.toLowerCase().indexOf(contactSearch) > -1 ||
                row.last_name.indexOf(contactSearch) > -1 ||
                row.last_name.toLowerCase().indexOf(contactSearch) > -1 ||
                row.position.indexOf(contactSearch) > -1 ||
                row.position.toLowerCase().indexOf(contactSearch) > -1
        );
    }

    // Reports

    const contactsHeaders = [
        { label: "ID", key: "id" },
        { label: "First Name", key: "first_name" },
        { label: "Last Name", key: "last_name" },
        { label: "Is Primary?", key: "is_primary" },
        { label: "Is Active?", key: "is_active" },
        { label: "Email", key: "email" },
        { label: "Phone Number", key: "phoneNumber" },
        { label: "Position", key: "position" }
    ];

    const contactReport = {
        data: pageData.contacts,
        headers: contactsHeaders,
        filename: `contacts_${pageData.client?.company}_${pageData.profileId}_report.csv`
    };

    return (
        <>
            <Tile light={true} className="row">
                <h5>Contacts</h5>
                <p className="mb-1 text-sm">All contacts associated with this client.</p>
                <ClientContactsList editContactSetup={editContactSetup} editContactID={editContactID} setEditContactID={setEditContactID} editContact={editContact} editContactForm={editContactForm} openEditContactModal={openEditContactModal} setOpenEditContactModal={setOpenEditContactModal} deleteContact={deleteContact} contactsToDel={contactsToDel} setContactsToDel={setContactsToDel} openDeleteContactModal={openDeleteContactModal} setOpenDeleteContactModal={setOpenDeleteContactModal} deleteContact={deleteContact} phoneInput={phoneInput} setPhoneInput={setPhoneInput} addContact={addContact} curDate={curDate} addContactForm={addContactForm} openAddContactModal={openAddContactModal} setOpenAddContactModal={setOpenAddContactModal} error={error} setError={setError} activeCheck={activeCheck} rows={contactsData} totalItems={totalItems} currentPageSize={currentPageSize} setCurrentPageSize={setCurrentPageSize} setFirstRowIndex={setFirstRowIndex} setContactSearch={setContactSearch} />
            </Tile>
        </>
    )
}

export default ClientContacts